import { render, staticRenderFns } from "./Spinner.component.vue?vue&type=template&id=f60d1bca&scoped=true"
import script from "./Spinner.component.vue?vue&type=script&lang=js"
export * from "./Spinner.component.vue?vue&type=script&lang=js"
import style0 from "./Spinner.component.vue?vue&type=style&index=0&id=f60d1bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60d1bca",
  null
  
)

export default component.exports